export default class GlobalHamburger {
    static exec() {
        const els = document.querySelectorAll('[data-component="global-hamburger"]');
        els.forEach(function(el) {
            new GlobalHamburger(el)
        })
    }

    constructor(element) {
        this.el = element
        this.hamburger = this.el.querySelector('[data-el="hamburger"]')
        this.close = this.el.querySelector('[data-el="close"]')
        this.menu = this.el.querySelector('[data-el="menu"]')

        const self = this;
        if (this.hamburger) {
            this.hamburger.addEventListener("click", function(event) {
                if (self.menu.dataset.state == 'close') {
                    self.menu.dataset.state = 'open';
                } else {
                    self.menu.dataset.state = 'close';
                }
            });
        }
        if (this.close) {
            this.close.addEventListener("click", function (event) {
                if (self.menu.dataset.state == 'close') {
                    self.menu.dataset.state = 'open';
                } else {
                    self.menu.dataset.state = 'close';
                }
            })
        }
    }
}